<template>
  <div
    class="button-group-header"
    :class="{ 'dark-mode': darkMode, }"
  >
    <ButtonGroup>
      <TacheButton
        v-if="isLogged"
      />
      <ButtonClassic
        v-if="!isLogged || hasPerm('view_liste')"
        id="bouton_panier"
        v-tooltip="{
          content: $t(
            'panier.x-selection-dans-panier',
            panier?.quantite_ligne,
            { selection: panier?.quantite_ligne, }
          ),
          placement: 'bottom',
          delay: { show: 800, },
        }"
        variant="solid"
        color="secondary"
        size="medium"
        @click="$router.push({ name: 'panier', })"
      >
        <IconPanier
          height="16"
          width="16"
        />
        <InfiniteLoader v-if="isFetchingPanier" />
        <Counter
          v-if="linesInPanier > 0 && !isFetchingPanier"
          :value="spaceNumber(linesInPanier)"
          size="small"
        />
      </ButtonClassic>
    </ButtonGroup>
    <ButtonClassic
      v-if="showChoixPays"
      v-tooltip="{
        content: $t('catalogue-public.changer-de-pays'),
        placement: 'bottom',
        delay: { show: 800, },
      }"
      variant="special"
      color="primary"
      size="medium"
      class="header-pays-button"
      icon="left"
      :label="$t(`catalogue-public.pays-${cataloguePublicPays}`)"
      @click="$modal.show('modal_choix_pays_catalogue_public')"
    >
      <template #left-icon>
        <UilGlobe />
      </template>
    </ButtonClassic>
    <ButtonClassic
      v-if="!isLogged"
      variant="special"
      color="primary"
      size="medium"
      class="header-login-button"
      icon="left"
      :label="$t('action.se-connecter')"
      @click="openConnexionModal()"
    >
      <template #left-icon>
        <UilUser />
      </template>
    </ButtonClassic>
    <template
      v-if="isLogged"
    >
      <ModalListesCreation @open-quick-list="listName = $event" />
      <ModalListesSaisieRapide :list-name="listName" />
      <ModalImportPanier />
    </template>
    <ModalConnexion v-if="!isLogged" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  ButtonClassic,
  ButtonGroup,
  Counter,
  InfiniteLoader,
  spaceNumber,
} from "@lde/core_lde_vue";
import { UilGlobe, UilUser } from "@lde/vue-unicons";

import ModalListesCreation from "@/components/modals/ModalListesCreation.vue";
import ModalListesSaisieRapide from "@/components/modals/ModalListesSaisieRapide.vue";
import ModalImportPanier from "@/components/modals/ModalImportPanier.vue";
import ModalConnexion from "@/components/modals/ModalConnexion.vue";
import IconPanier from "@/components/icons/IconPanier.vue";
import TacheButton from "@/components/taches/TacheButton.ts.vue";

/**
 * Groupe de boutons dans la topbar à gauche de l'avatar.
 */
export default {
  name: "ButtonGroupHeader",
  components: {
    ButtonGroup,
    ButtonClassic,
    Counter,
    ModalListesCreation,
    ModalListesSaisieRapide,
    ModalImportPanier,
    ModalConnexion,
    InfiniteLoader,
    IconPanier,
    TacheButton,
    UilGlobe,
    UilUser,
  },
  props: {
    /**
     * La couleur de fond du parent est sombre.
     */
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPopoverOpen: false,
      listName: "",
    };
  },
  computed: {
    ...mapGetters([
      "panier",
      "user",
      "isFetchingPanier",
      "preferences",
      "isHorsMarche",
      "isLogged",
      "hasPerm",
      "organismeActuel",
      "isCataloguePublicActif",
      "cataloguePublicPays",
    ]),
    /**
     * Le visiteur du catalogue public peut changer le pays choisi à son arrivée.
     */
    showChoixPays() {
      return !this.isLogged && this.isCataloguePublicActif && Boolean(this.cataloguePublicPays);
    },
    isTotalInBar: {
      get() {
        return this.preferences?.totalInBar;
      },
      set(totalInBar) {
        this.$store.commit("updatePreferences", { totalInBar });
      },
    },
    linesInPanier() {
      return this.panier?.quantite_ligne;
    },
    tooltipTitle() {
      if (this.panier) {
        return this.$t(
          "selection.x-selection-en-cours",
          spaceNumber(this.linesInPanier),
          { selection: spaceNumber(this.linesInPanier) },
        );
      }
      return this.$t("selection.aucune-liste-selectionnee");
    },
  },
  methods: {
    spaceNumber,
    openConnexionModal() {
      window.dispatchEvent(new CustomEvent("modal-connexion:open", { detail: null }));
      this.$modal.show("modal_connexion");
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/styles/components/buttons/button_group_header.scss";
</style>
